"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    cancel: 'ביטול',
    confirm: 'אישור',
    close: 'סגירה',
    back: 'חזרה',
    save_as_group: 'שמירה כקבוצה חדשה',
    save_as_group_mobile: 'שמירה כקבוצה',
    groupsSelectListTools_class: 'כיתות',
    groupsSelectListTools_groups: 'קבוצות',
    groupsSelectListTools_newGroup: 'קבוצה חדשה +',
    groupsSelectListTools_groupNotFound: 'לא מצאתי',
    groupsSelectListTools_newGroup2: 'יצירת קבוצה חדשה',
    groupsSelectListTools_students: 'תלמידים יחידים',
    selectedItems_close_btn: 'סגירה',
    selectedItems_open_btn: 'הציגו הכל',
    inlineTools_groupsSelector_class: 'כיתות',
    inlineTools_groupsSelector_groups: 'וקבוצות',
    inlineTools_studentsSelector: 'תלמידים יחידים',
    groupsSelector_offset_title: 'בחרו כיתות וקבוצות',
    groupsSelector_offset_title_male: 'בחר כיתות וקבוצות',
    groupsSelector_offset_title_female: 'בחרי כיתות וקבוצות',
    studentsSelector_offset_title: 'בחירת תלמידים יחידים',
    studentsSelector_groupsSelect_title: 'מתוך:',
    studentsSelector_groupsSelect_all: 'כל התלמידים בסביבה',
    studentsSelector_groupsSelect_singleStudents: 'תלמידים בודדים',
    studentsSelector_groupsSelectPlaceholder: 'חיפוש לפי כיתה או קבוצה',
    studentsSelector_studentsSearchPlaceholder: 'חיפוש לפי שם תלמיד',
    studentsSelector_edit_group_name_tooltip: 'עריכת שם הקבוצה',
    group_name: 'שם לקבוצה',
    input_group_name: 'תנו שם לקבוצה',
    input_group_name_male: 'תן שם לקבוצה',
    input_group_name_female: 'תני שם לקבוצה',
    input_new_group_name: 'תנו שם חדש לקבוצה',
    input_new_group_name_male: 'תן שם חדש לקבוצה',
    input_new_group_name_female: 'תני שם חדש לקבוצה',
    input_placeholder_male: 'הקלד כאן את שם הקבוצה',
    input_placeholder_female: 'הקלידי כאן את שם הקבוצה',
    create_group_error_title: 'משהו קרה, הקבוצה לא נשמרה',
    create_group_name_exists_error_title: 'שם הקבוצה קיים כבר',
    create_group_error_sub_title: 'אל דאגה, ניתן לחזור לאחור ולנסות שוב'
  },
  ar: {
    cancel: 'إلغاء',
    confirm: 'موافقة',
    close: 'إغلاق',
    back: 'عودة',
    save_as_group: 'حفظ كمجموعة جديدة',
    save_as_group_mobile: 'حفظ كمجموعة',
    groupsSelectListTools_class: 'صفوف',
    groupsSelectListTools_groups: 'مجموعات',
    groupsSelectListTools_newGroup: 'مجموعة جديدة +',
    groupsSelectListTools_groupNotFound: 'لم أجد',
    groupsSelectListTools_newGroup2: 'مجموعة جديدة',
    groupsSelectListTools_students: 'تلاميذ',
    selectedItems_close_btn: 'إغلاق',
    selectedItems_open_btn: 'اعرض الكلّ',
    inlineTools_groupsSelector_class: 'صفوف',
    inlineTools_groupsSelector_groups: 'مجموعات',
    inlineTools_studentsSelector: 'تلاميذ أفراد',
    groupsSelector_offset_title: 'اختاروا صفوفًا ومجموعات',
    groupsSelector_offset_title_male: 'اختر صفوفًا ومجموعات',
    groupsSelector_offset_title_female: 'اختاري صفوفًا ومجموعات',
    studentsSelector_offset_title: 'اختيار تلاميذ',
    studentsSelector_groupsSelect_title: 'من بين:',
    studentsSelector_groupsSelect_all: 'كلّ التلاميذ في البيئة',
    studentsSelector_groupsSelect_singleStudents: 'تلاميذ منفردون',
    studentsSelector_groupsSelectPlaceholder: 'بحث حسب الصفّ أو المجموعة',
    studentsSelector_studentsSearchPlaceholder: 'بحث حسب اسم التلميذ',
    studentsSelector_edit_group_name_tooltip: 'تحرير اسم المجموعة',
    group_name: 'اسمًا للمجموعة',
    input_group_name: 'اختاروا اسمًا للمجموعة',
    input_group_name_male: 'اكتب اسماً للمجموعة',
    input_group_name_female: 'اكتبي اسماً للمجموعة',
    input_new_group_name: 'اختاروا اسمًا جديدًا للمجموعة',
    input_new_group_name_male: 'اختر اسمًا جديدًا للمجموعة',
    input_new_group_name_female: 'اختاري اسمًا جديدًا للمجموعة',
    input_placeholder_male: 'اكتب هنا اسم المجموعة',
    input_placeholder_female: 'اكتبي هنا اسم المجموعة',
    create_group_error_title: 'حدث خلل... المجموعة لم تُحفظ',
    create_group_name_exists_error_title: 'اسم المجموعة موجود من قبل',
    create_group_error_sub_title: 'لا مشكلة، يمكن العودة إلى الوراء والمحاولة مجدّدًا'
  },
  en: {
    cancel: 'Cancel',
    confirm: 'Next',
    close: 'Close',
    back: 'Back',
    save_as_group: 'Create new group',
    save_as_group_mobile: 'Create group',
    groupsSelectListTools_class: 'classes',
    groupsSelectListTools_groups: 'groups',
    groupsSelectListTools_newGroup: 'new group +',
    groupsSelectListTools_groupNotFound: 'Not find',
    groupsSelectListTools_newGroup2: 'new group',
    groupsSelectListTools_students: 'single students',
    selectedItems_close_btn: 'close',
    selectedItems_open_btn: 'show more',
    inlineTools_groupsSelector_class: 'classes',
    inlineTools_groupsSelector_groups: 'and groups',
    inlineTools_studentsSelector: 'single students',
    groupsSelector_offset_title: 'select classes\\groups',
    groupsSelector_offset_title_male: 'select classes\\groups',
    groupsSelector_offset_title_female: 'select classes\\groups',
    studentsSelector_offset_title: 'Select single students',
    studentsSelector_groupsSelect_title: 'from:',
    studentsSelector_groupsSelect_all: 'All students in the environment',
    studentsSelector_groupsSelect_singleStudents: 'Single students',
    studentsSelector_groupsSelectPlaceholder: 'search classes and groups',
    studentsSelector_studentsSearchPlaceholder: 'search students',
    studentsSelector_edit_group_name_tooltip: 'edit group name',
    group_name: 'Group name',
    input_group_name: 'Group name',
    input_group_name_male: 'Group name',
    input_group_name_female: 'Group name',
    input_new_group_name: 'group name',
    input_new_group_name_male: 'group name',
    input_new_group_name_female: 'group name',
    create_group_error_title: 'something went wrong',
    create_group_name_exists_error_title: 'the group name is already used',
    create_group_error_sub_title: 'you can click back and try again'
  }
};